import { render, staticRenderFns } from "./AddContentToCollectionModal.vue?vue&type=template&id=49ea0946&lang=pug&"
import script from "./AddContentToCollectionModal.vue?vue&type=script&lang=js&"
export * from "./AddContentToCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports